import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function ProductReveal() {
  return <section className="bg-teal-light py-11 sm:py-16" aria-labelledby="reveal-title" data-id="element-114" data-mp="2r5aj6qh4va0w">
      <div className="mx-auto max-w-2xl px-5 text-center sm:px-8" data-id="element-115" data-mp="361rujhpboong">
        <h2 id="reveal-title" className="font-display text-[32px] font-semibold uppercase leading-[1.05] tracking-tightish text-navy-deep sm:text-5xl" data-id="element-116" data-mp="3619z2nahiegl">
          Speech Therapy Clinical Toolkit™
        </h2>
        <p className="mt-2 text-[12.5px] font-semibold uppercase tracking-[0.12em] text-teal-dark sm:text-base" data-id="element-117" data-mp="28ejfa4fx0btw">
          The complete professional speech therapy system
        </p>

        <p className="mx-auto mt-4 max-w-xl text-[14.5px] leading-snug text-navy-soft sm:text-lg" data-id="element-118" data-mp="2ich16laaxwjc">
          A professional ready-to-use resource system created to help Speech Therapists and SLPs
          spend less time preparing, searching and organizing — and more time focused on actual
          therapy.
        </p>

        <p className="mt-6 font-display text-[19px] font-semibold uppercase leading-snug text-navy-deep sm:text-2xl" data-id="element-119" data-mp="1b1h6cf18yrnb">
          Less preparation.
          <br data-id="element-120" data-mp="1f0q03jwaepiv" />
          More ready-to-use clinical support.
        </p>

        <div className="mt-6 flex items-center justify-center gap-2 text-[12px] font-semibold uppercase tracking-[0.12em] text-navy sm:text-sm" data-id="element-121" data-mp="1jukeq8x1ceb3">
          <span className="rounded-full bg-ivory-light px-3.5 py-2 shadow-card" data-id="element-122" data-mp="1ou6rkh8ybsjd">Open</span>
          <ArrowRightIcon className="h-3.5 w-3.5 text-teal" aria-hidden="true" data-id="element-123" data-mp="s463ylkbji3n" />
          <span className="rounded-full bg-ivory-light px-3.5 py-2 shadow-card" data-id="element-124" data-mp="w3yj5h47wmhz">Choose</span>
          <ArrowRightIcon className="h-3.5 w-3.5 text-teal" aria-hidden="true" data-id="element-125" data-mp="1116scs7e1g73" />
          <span className="rounded-full bg-ivory-light px-3.5 py-2 shadow-card" data-id="element-126" data-mp="162w121751hs0">Use</span>
        </div>
      </div>
    </section>;
}